export default __webpack_public_path__ + "static/kindbody-logo-165051857e7a09c20e076f4a39036b51.png";